import { Link } from "react-router-dom";
import { Youtube, Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-32 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4">
            <img
              src="/hoh-vibes-logo-128.png"
              alt="HOH_Vibes"
              width={56}
              height={56}
              className="w-14 h-14 rounded-full object-cover ring-1 ring-[#D4AF37]/40"
            />
            <div className="font-serif-display text-3xl text-white">HOH<span className="text-[#D4AF37]">_</span>Vibes</div>
          </div>
          <p className="text-neutral-400 mt-4 max-w-md leading-relaxed">
            Inspiring the world through music, faith and creativity. Premium gospel audio and Power BI templates crafted for purpose-driven creators.
          </p>
          <div className="flex gap-3 mt-6">
            <a data-testid="footer-youtube" href="https://youtube.com" target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/15 rounded-full flex items-center justify-center text-neutral-300 hover:text-[#D4AF37] hover:border-[#D4AF37]"><Youtube size={16} /></a>
            <a data-testid="footer-instagram" href="https://instagram.com" target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/15 rounded-full flex items-center justify-center text-neutral-300 hover:text-[#D4AF37] hover:border-[#D4AF37]"><Instagram size={16} /></a>
            <a data-testid="footer-email" href="mailto:hanson@hohvibes.com" className="w-10 h-10 border border-white/15 rounded-full flex items-center justify-center text-neutral-300 hover:text-[#D4AF37] hover:border-[#D4AF37]"><Mail size={16} /></a>
          </div>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Shop</div>
          <ul className="space-y-2 text-neutral-300 text-sm">
            <li><Link to="/music" className="hover:text-[#D4AF37]">Music Store</Link></li>
            <li><Link to="/templates" className="hover:text-[#D4AF37]">Power BI Templates</Link></li>
            <li><Link to="/ebooks" className="hover:text-[#D4AF37]">E-books</Link></li>
            <li><Link to="/merch" className="hover:text-[#D4AF37]">Merch</Link></li>
            <li><Link to="/cart" className="hover:text-[#D4AF37]">Basket</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Services</div>
          <ul className="space-y-2 text-neutral-300 text-sm">
            <li><Link to="/church-builder" className="hover:text-[#D4AF37]">Church Builder</Link></li>
            <li><Link to="/attendance" data-testid="footer-attendance" className="hover:text-[#D4AF37]">HOH Attendance</Link></li>
            <li><Link to="/projection" data-testid="footer-projection" className="hover:text-[#D4AF37]">Worship Projection</Link></li>
            <li><Link to="/app" className="hover:text-[#D4AF37]">HOH Studio App</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Company</div>
          <ul className="space-y-2 text-neutral-300 text-sm">
            <li><Link to="/about" className="hover:text-[#D4AF37]">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37]">Contact</Link></li>
            <li><Link data-testid="footer-privacy" to="/privacy" className="hover:text-[#D4AF37]">Privacy</Link></li>
            <li><Link data-testid="footer-terms" to="/terms" className="hover:text-[#D4AF37]">Terms</Link></li>
            <li><Link to="/admin/login" className="hover:text-[#D4AF37]">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-neutral-500 tracking-widest uppercase">
        © {new Date().getFullYear()} HOH_Vibes · Made with purpose ·{" "}
        <Link data-testid="footer-privacy-bottom" to="/privacy" className="hover:text-[#D4AF37]">Privacy</Link>
        {" · "}
        <Link data-testid="footer-terms-bottom" to="/terms" className="hover:text-[#D4AF37]">Terms</Link>
      </div>
    </footer>
  );
}
